<template>
  <khrc-navbar/>
  <admin-details-component />
</template>

<script>
import AdminDetailsComponent from "@/components/AdminDetailsComponent";
import KhrcNavbar from "@/components/KhrcNavbar.vue";
export default {
  components: {
    KhrcNavbar,
    AdminDetailsComponent,
  },
};
</script>

<style></style>
